import { Navigate, type RouteObject } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import Services from '../pages/Services';
import News from '../pages/News';
import PrivacyTerms from '../pages/PrivacyTerms';
import NotFound from '../pages/NotFound';
import Layout from '../components/layout/Layout';
import Deliver from '../pages/Deliver';
import RequestQuote from '../pages/RequestQuote';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'services',
        element: <Services />,
      },
      {
        path: 'news',
        element: <News />,
      },
      {
        path: 'request-quote',
        element: <RequestQuote />,
      },
      {
        path: 'custom-quote',
        element: <Navigate to="/request-quote" replace />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyTerms />, 
      },
      {
        path: 'terms-conditions',
        element: <PrivacyTerms />, 
      },
      {
        path: '*',
        element: <NotFound />,
      }
    ],
  },
  {
    path: '/deliver',
    element: <Deliver />, 
  },
];
